"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const vue_property_decorator_1 = require("vue-property-decorator");
let SuscripcionNewsletter = class SuscripcionNewsletter extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.email = "";
        this.tipo_id = 0;
        this.operacion_id = 0;
        this.loading = false;
    }
    get tiposOpciones() {
        let items = [];
        items.push({ id: 0, slug: "", nombre: "Indistinto" });
        if (this.tipos.length) {
            this.tipos.forEach(tipo => {
                items.push(tipo);
            });
        }
        return items;
    }
    get operacionesOpciones() {
        let items = [];
        items.push({ id: 0, slug: "", nombre: "Indistinto" });
        if (this.operaciones.length) {
            this.operaciones.forEach(operacion => {
                items.push(operacion);
            });
        }
        return items;
    }
    get isValid() {
        return this.email && this.loading === false;
    }
    submit(e) {
        e.preventDefault();
        this.loading = true;
        axios_1.default
            .post("/api/newsletter-suscripcion", {
            email: this.email,
            tipo_id: this.tipo_id,
            operacion_id: this.operacion_id
        })
            .then(response => {
            this.loading = false;
            this.email = "";
            this.tipo_id = 0;
            this.operacion_id = 0;
            this.$bvToast.toast("Se registro para recibir noticias a su correo.", {
                solid: true,
                title: `Suscripción`,
                variant: `success`
            });
        })
            .catch(error => {
            this.loading = false;
            this.email = "";
            this.tipo_id = 0;
            this.operacion_id = 0;
            this.$bvToast.toast(error, {
                solid: true,
                title: `Error`,
                variant: `danger`
            });
        });
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Array, required: true }),
    __metadata("design:type", Array)
], SuscripcionNewsletter.prototype, "tipos", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Array, required: true }),
    __metadata("design:type", Array)
], SuscripcionNewsletter.prototype, "operaciones", void 0);
SuscripcionNewsletter = __decorate([
    vue_property_decorator_1.Component({})
], SuscripcionNewsletter);
exports.default = SuscripcionNewsletter;
